import { render, staticRenderFns } from "./ProfileCoverage.vue?vue&type=template&id=229b866c"
import script from "./ProfileCoverage.vue?vue&type=script&lang=js"
export * from "./ProfileCoverage.vue?vue&type=script&lang=js"
import style0 from "./ProfileCoverage.vue?vue&type=style&index=0&id=229b866c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports